import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '../../modules/Pages/Login';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { RecuperarClave } from '../../modules/Pages/Recuperar';
import DatosSolicitud from '../../modules/Pages/Solicitud/Datos';
import { AuthCallback } from '../../modules/Pages/AuthCallback';
import { SolicitudesInstalacion } from '../../modules/Pages/Instalacion/Solicitudes';

export const AppRutas = () => {
  const { isAuth } = useSelector((state: RootState) => state.auth);

  return (
    <>
      {' '}
      {!isAuth ? (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/recuperarClave"
            element={<RecuperarClave />}
          />
          <Route
            path="/solicitud/:id/datos"
            element={<DatosSolicitud />}
          />
          <Route
            path="/instalacion/:id/solicitudes"
            element={<SolicitudesInstalacion />}
          />
          <Route path="/*" element={<Navigate to="/login" />} />
        </Routes>
      ) : null}
    </>
  );
};
